var map = {
	"./cmn_msg_ar.json": 2061,
	"./cmn_msg_de.json": 2062,
	"./cmn_msg_en.json": 2063,
	"./cmn_msg_es.json": 2064,
	"./cmn_msg_fr.json": 2065,
	"./cmn_msg_it.json": 2066,
	"./cmn_msg_ja.json": 2067,
	"./cmn_msg_nl.json": 2068,
	"./cmn_msg_pt.json": 2069,
	"./cmn_msg_zh.json": 2070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2060;